// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"371":"fd29b579","453":"51b20bab"}[chunkId] + ".chunk.js";
};